<template>
  <div>
    <el-button type='primary' class='openAll' @click='openAll'>全开柜门</el-button>
    <!-- <el-button type='primary' class='initAll' @click="initAll">初始化锁</el-button> -->
    <el-button type='primary' class='queryAll' @click="queryAll">查询锁状态</el-button>
    <el-button type='primary' class='queryCabinet' @click="queryCabinet">查询柜子状态</el-button>
    <el-button type='primary' class='reset' @click="reset">重启</el-button>
    <!-- 列表 -->
    <el-table v-loading="loading" element-loading-text="拼命加载中" stripe :data="tableData">
      <el-table-column label="柜门 ID" prop="objectId" min-width="180">
      </el-table-column>
      <el-table-column label="所属副柜" prop="section" min-width="110">
      </el-table-column>
      <el-table-column label="柜门号 " prop="port" min-width="110">
      </el-table-column>
      <el-table-column label="状态" prop="status" min-width="110">
        <template scope="scope">
            <el-tag size="medium" :type="scope.row.status === 'disabled' ? 'danger' : 'success' " >{{scope.row.status ==='disabled' ? '异常': '正常'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="柜门状态" prop="unlocked" min-width="110">
          <template scope="scope">
            <span>{{scope.row.unlocked ? '已打开': '关闭'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="柜门类型" prop="type" min-width="110">

      </el-table-column>
      <el-table-column label="操作"  fixed='right' width='150'>
        <template scope="scope">
          <el-button size="small" @click="openLock(scope.row)">开门</el-button>
          <el-button size="small" @click="eidtLock(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 弹框 编辑 -->
    <el-dialog title="编辑" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="柜门类型" :label-width="formLabelWidth">
          <el-select v-model="form.type" placeholder="使用状态">
            <el-option label="小柜门" value="s"></el-option>
            <el-option label="中柜门" value="m"></el-option>
            <el-option label="大柜门" value="l"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用状态" :label-width="formLabelWidth">
          <el-select v-model="form.status" placeholder="使用状态">
            <el-option label="正常" value="normal"></el-option>
            <el-option label="损坏" value="damaged"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureOpt">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync='dialogFormVisible2' :close-on-click-modal='close'>
      <img :src="imgSrc" alt="">
      <div class="pressingMsg">{{ pressingMsg }}</div>
      <div slot="footer" class="dialog-footer" v-if="allStep">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="endInit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import util from '../../util/util';
export default {
  data() {
    return {
      tableData: [],
      loading: true,
      formLabelWidth: '120px',
      form: {
        type: '',
        status: ''
      },
      dialogFormVisible: false,
      dialogFormVisible2: false,
      editData: {},
      close: false,
      allStep: false,
      imgSrc: require('./../../assets/continue.png'),
      pressingMsg: '',
      arr: []
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      axios.get('/lockers', {
        params: {
          limit: 360,
          skip: 0,
          where: {
            cabinet: {
              __type: 'Pointer',
              className: 'Cabinet',
              objectId: this.$route.query.cabinetId
            },
          },
          include: 'order.user',
          order: 'section,port'
        }
      }).then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].type == 's') {
            response.data[i].type = '小柜门'
          }
          else if (response.data[i].type == 'm') {
            response.data[i].type = '中柜门'
          }
          else {
            response.data[i].type = '大柜门'
          }
          this.arr.push(response.data[i].section);
        }
        this.arr = this.arr.unique3();
        this.tableData = response.data
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
      })
    },
    // 单开柜门
    openLock(row) {
      this.$confirm('此操作将打开柜门, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post('/cabinets/' + this.$route.query.cabinetId + '/commands', {
          cmd: 'unlock_locker',
          data: {
            locker_id: row.objectId
          }
        }).then((response) => {
          this.$message({
            type: 'success',
            message: '开门成功!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    //重置柜子
    reset() {
      this.$confirm('此操作将重启机柜, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post('/cabinets/' + this.$route.query.cabinetId + '/commands', {
          cmd: 'reboot',
          data: {}
        }).then((response) => {
          this.$message({
            type: 'success',
            message: '重启成功!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    // 编辑柜门
    eidtLock(row) {
      this.dialogFormVisible = true;
      this.editData = row;
      this.form.status = row.status;
      this.form.type = row.type;
    },
    sureOpt() {
      this.dialogFormVisible = false;
      axios.put('/lockers/' + this.editData.objectId, this.form).then((response) => {
        this.getData();
      })
    },
    // 全开
    openAll() {
      let self = this;
      this.$confirm('此操作将全打开柜门, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.dialogFormVisible2 = true;
        (function f(i) {
          self.imgSrc = require('./../../assets/openLock.gif')
          self.pressingMsg = '打开' + (i + 1) + '号副柜！';
          axios.post('/cabinets/' + self.$route.query.cabinetId + '/commands', {
            'cmd': 'unlock_section',
            data: {
              'section': self.arr[i]
            }
          }).then((response) => {
            if (i == self.arr.length - 1) {
              self.dialogFormVisible2 = false;
              self.getData();
              return;
            }
            f(i + 1);
          }).catch((error) => {
            self.dialogFormVisible2 = false;
          })
        })(0);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    // 全查
    queryAll() {
      let self = this;
      this.$confirm('此操作将查询所有柜门, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.dialogFormVisible2 = true;
        (function f(i) {
          self.imgSrc = require('./../../assets/queryLock.gif')
          self.pressingMsg = '查询' + (i + 1) + '号副柜！';
          axios.post('/cabinets/' + self.$route.query.cabinetId + '/commands', {
            'cmd': 'query_section',
            data: {
              'section': self.arr[i]
            }
          }).then((response) => {
            if (i == self.arr.length - 1) {
              self.dialogFormVisible2 = false;
              self.getData();
              return;
            }
            f(i + 1);
          }).catch((error) => {
            self.dialogFormVisible2 = false;
          })
        })(0);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    initAll() {
      let self = this;
      console.log(self.$route.query.section)
      return;
      this.$confirm('此操作将初始化机柜, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.dialogFormVisible2 = true;
        self.imgSrc = require('./../../assets/continue.png')
        self.pressingMsg = '开始初始化流程！';
        axios.post('/cabinets/' + this.$route.query.cabinetId + '/commands', { cmd: 'init_start' }).then((response) => {
          (function f(i) {
            self.imgSrc = require('./../../assets/openLock.gif')
            self.pressingMsg = '打开' + i + '号副柜！';
            axios.post('/cabinets/' + self.$route.query.cabinetId + '/commands', {
              'cmd': 'unlock_section',
              data: {
                'section': i
              }
            }).then((response) => {
              if (i == self.$route.query.section) {
                self.dialogFormVisible2 = false;
                (function f(j) {
                  self.imgSrc = require('./../../assets/queryLock.gif')
                  self.pressingMsg = '查询' + j + '号副柜！';
                  axios.post('/cabinets/' + self.$route.query.cabinetId + '/commands', {
                    'cmd': 'query_section',
                    data: {
                      'section': j
                    }
                  }).then((response) => {
                    if (i == self.$route.query.section) {
                      self.dialogFormVisible2 = false;
                      self.allStep = true;
                      self.endInit();
                      return;
                    }
                    f(j + 1);
                  }).catch((error) => {
                    self.dialogFormVisible2 = false;
                  })
                })(1);
                return;
              }
              f(i + 1);
            }).catch((error) => {
              self.dialogFormVisible2 = false;
            })
          })(1);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    endInit() {
      let self = this;
      self.imgSrc = require('./../../assets/continue.png')
      self.pressingMsg = '结束初始化流程！';
      axios.post('/cabinets/' + this.$route.query.cabinetId + '/commands', { cmd: 'init_end' }).then((response) => {
        self.getData();
      }).catch((error) => {
        self.dialogFormVisible2 = false;
      })
    },
    queryCabinet() {
      let self = this;
      this.$confirm('此操作将查询柜子状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.dialogFormVisible2 = true;
        self.imgSrc = require('./../../assets/queryLock.gif')
        self.pressingMsg = '查询柜子状态！';
        axios.post('/cabinets/' + self.$route.query.cabinetId + '/commands', {
          'cmd': 'query_cabinet',
          data: {}
        }).then((response) => {
          self.dialogFormVisible2 = false;
          this.$notify({
          title: '成功',
            message: response.data,
            type: 'success'
          });
          self.getData();
        }).catch((error) => {
          self.dialogFormVisible2 = false;
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss' scoped >
@import 'src/styles/mixin.scss';
.initAll,
.openAll,
.queryAll,
.queryCabinet,
.reset {
  @include floatBtn;
  margin-right: 5px;
  margin-left: 0px;
}

.pressingMsg {
  position: absolute;
  left: 200px;
  top: 0;
  font-size: 20px;
  line-height: 240px;
}
</style>



// WEBPACK FOOTER //
// src/views/cabinet/CabinetDetail.vue?475c07e8